import TextAlignment from './TextAlignment';

export default TextAlignment;
